// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCcCkJjHYF6HzCflozeRRW0KVaC28haAaw",
  authDomain: "vastudesignconsultants-735ed.firebaseapp.com",
  databaseURL: "https://vastudesignconsultants-735ed-default-rtdb.firebaseio.com",
  projectId: "vastudesignconsultants-735ed",
  storageBucket: "vastudesignconsultants-735ed.firebasestorage.app",
  messagingSenderId: "951945432580",
  appId: "1:951945432580:web:53552a2a76a3b6b1b0ef51",
  measurementId: "G-5PP6T6FDWE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage, app };